<template>
	<div>
		<pageHead></pageHead>
		<div class="service-main">
			<page-banner :title="'服务内容'" :breadTxt="'安全培训'" :tipTxt="'提供“规范、科学、公正、专业、诚信”的等级保护测评服务'"></page-banner>
			
			<p class="t-align-center serviceT mt-50">安全培训</p>
			<p class="t-align-center serviceT mt-10 mb-20">Safety Training Service</p>
			<div class="m-0auto maxw-1400 dp-f justify-between pb-50">
				<div>
					<p class="fz-24 f-blue line-50 f-bold">安全培训概述</p>
					<p class="t-indent2 line-26 fz-18">安全培训是指安全专家为各信息系统管理人员提供信息安全相关培训，通过培训，将网络安全发展的新动态、新理论和新信息传递给接受培训的人员，培养参加培训人员在网络安全方面的技能和水平，充分了解网络安全知识，提高防护网络安全技能和水平。</p>
					<img src="../../assets/img/service/u29.png" alt="">
					<img src="../../assets/img/service/u30.png" alt="">
				</div>
				<div>
					<div class="bg-blue t-align-center">
						<p class="fz-24 f-white f-bold">安全培训意义</p>
					</div>
					<div class="li-w">
						<li>了解目前国内国际网络安全形式；</li>
						<li>熟悉我国网络安全有关政策法规和标准；</li>
						<li>提高掌握等级保护相关政策的水平；</li>
						<li>提高管理人员的安全技能与信息安全意识；</li>
						<li>提高开展本单位或行业等级保护工作的思路和水平；</li>
						<li>提高信息安全意识，了解和掌握信息安全事件的形势和趋势；</li>
						<li>清楚如何从资源分配（人、财、物）、效益分析等方面对本单位或本行业的等级保护工作做出决策；</li>
						<li>深入理解信息安全等级保护制度，熟悉等级保护中各个环节的工作思路和方法，能够组织开展好本单位等级保护工作；</li>
						<li>通过安全培训，能够依据等级保护要求组织本单位安全规划和整改方案的设计、实施和运行维护。</li>
					</div>
				</div>
			</div>
		</div>
		
		<page-foot></page-foot>
	</div>
</template>

<script>
	import pageHead from '../../components/pageHead'
	import pageBanner from '../../components/pageBanner'
	import pageFoot from '../../components/pagefoot'
	export default{
		components:{
			pageHead,
			pageBanner,
			pageFoot
		},
		data(){
			return {
				
			}
		},
		methods:{
			
		}
	}
</script>

<style scoped>
.proBox{
	width: 100%;
	max-width: 1400px;
	height: auto;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
	margin: 20px auto;
	border-radius: 15px;
}
.serviceT{
	font-size: 24px;
	font-weight: 800;
}
.maxw-1400>div{
	width: 48%;
}
.maxw-1400>div:first-child img{
	width: 100%;
	margin-top: 30px;
}
.maxw-1400>div:last-child{
	background-color: #effffc;
	height: inherit;
	border-top-left-radius: 15px;
	border-top-right-radius: 15px;
}
.bg-blue{
	background-color: #4264b5;
	height: 60px;
	line-height: 60px;
	border-top-left-radius: 15px;
	border-top-right-radius: 15px;
}
.li-w{
	padding: 30px;
	font-size: 18px;
	height: 96%;
	line-height: 300%;
	letter-spacing: 0.1em;
	color: #808080;
	display: flex;
	flex-direction: column;
}
li::marker{
	color: #4264b5;
	font-size: 2rem;
}
</style>